import { SvgIcon } from '@mui/material';

const BakeryIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="17"
        height="16"
        viewBox="0 0 17 16"
        fill="none"
      >
        <path
          d="M15.066 5.078a1.9 1.9 0 0 1-1.9 1.9 2 2 0 0 1-1.65-.95 3.3 3.3 0 0 1-5.8 0 2 2 0 0 1-1.65.95 1.9 1.9 0 0 1-1.9-1.9 1.85 1.85 0 0 1 1.9-1.85 2 2 0 0 1 1.3.5 3.3 3.3 0 0 1 6.5 0 2 2 0 0 1 1.3-.5 1.85 1.85 0 0 1 1.9 1.85"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="m13.767 6.928-.5 7.7h-9.3l-.5-7.7m3.6 7.7-.1-3.5m3.199 3.5.1-3.5m-6.401-5.75.5-.5m8.5.5.5-.5m-4.349-1 .5-.5m-2.049 1.6.5.5"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </SvgIcon>
  );
};

export default BakeryIcon;
